const ApproveRequestButton = ({ onClicked, title = "APPROVE REQUEST" }) => {
  return (
    <div
      data-testid="wo-approve-request"
      onClick={onClicked}
      className="cursor-pointer w-[180px] h-[32px] bg-blueColor rounded-[8px] flex items-center justify-center font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] text-white"
    >
      {title}
    </div>
  );
};

export default ApproveRequestButton;
